export default __webpack_public_path__ + "static/media/inspection.c801204e.png";